import { useState } from "react";
import { useT } from "../lib/i18n";

export function Faq() {
  const t = useT();
  const copy = t.faq;
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section
      id="faq"
      className="border-t border-margin dark:border-paper/10 bg-margin/20 dark:bg-paper/[0.02]"
    >
      <div className="mx-auto max-w-3xl px-6 py-24">
        <p className="text-xs font-medium uppercase tracking-wider text-ink/50 dark:text-paper/50">
          {copy.label}
        </p>
        <h2 className="mt-2 font-display text-3xl sm:text-4xl font-semibold tracking-tight text-ink dark:text-paper">
          {copy.heading}
        </h2>

        <div className="mt-12 divide-y divide-margin rounded-2xl border border-margin dark:divide-paper/10 dark:border-paper/10 overflow-hidden">
          {copy.items.map((item, i) => {
            const open = openIdx === i;
            return (
              <div key={item.q} className="bg-paper dark:bg-ink">
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? null : i)}
                  aria-expanded={open}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left transition-colors hover:bg-ink/[0.02] dark:hover:bg-paper/[0.03]"
                >
                  <span className="font-medium text-ink dark:text-paper">
                    {item.q}
                  </span>
                  <svg
                    className={`h-4 w-4 flex-shrink-0 text-ink/50 dark:text-paper/50 transition-transform duration-150 ${open ? "rotate-180" : ""}`}
                    viewBox="0 0 12 12"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="2,4 6,8 10,4" />
                  </svg>
                </button>
                {open && (
                  <div className="px-6 pb-5 text-sm text-ink/70 dark:text-paper/70 leading-relaxed">
                    {item.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
